export function getFormattedAmount({amount, fractionDigits, currency}: FormatAmountRequest) {
	let floatValue = Number.parseFloat(String(amount))
	let formattedAmount = (floatValue / Math.pow(10, fractionDigits)).toFixed(fractionDigits || 0)
	return `${currency} ${formattedAmount}`
}

export interface FormatAmountRequest {
	amount: number
	fractionDigits: number
	currency: string
}
